import hpcData from "./hpc.pdf";

const data ={
    hpcData,
}

export default data